export default {
  BOOK_DEMO_LOCATIONS_SETUP: 'locations-setup:book-demo',
  WIZARD_READY: 'locations-setup:wizard-ready',
};
